<template>
  <Teleport to="body">
    <div v-if="globalLoading.active && !route.meta.hideSpinner" class="global-loading-overlay">
      <div class="css-spinner"></div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router'
import { globalLoading } from '../services/loading-state'

const route = useRoute()
</script>

<style scoped lang="scss">
.global-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999999;
  backdrop-filter: blur(2px);
  pointer-events: all;
}

.css-spinner {
  width: 60px;
  height: 60px;
  border: 6px solid #f3f3f3;
  border-top: 6px solid #154ec1;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
